// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Js__Js_exn from "melange.js/js_exn.js";
import * as Mapre_wire__Environment_codec from "../../shared/wire/environment_codec.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";

const empty = {
  source: /* Native */ 0,
  path: "Dockerfile",
  filename: "Dockerfile",
  content: "",
  context: ".",
  target: "",
  arguments: "{}"
};

function initial(request_id) {
  return {
    draft: empty,
    version: undefined,
    project_version: 0,
    request_id,
    loading: true,
    pending: false,
    conflict: false,
    message: "",
    history: /* [] */ 0,
    history_open: false,
    history_loading: false,
    next_version: undefined
  };
}

function draft(config) {
  if (/* tag */ typeof config !== "object" && typeof config !== "function") {
    return empty;
  }
  const config$1 = config._0;
  const path = config$1.dockerfile;
  let match;
  match = path.TAG === /* Repository */ 0 ? [
      /* Repository */ 1,
      path._0,
      "Dockerfile",
      ""
    ] : [
      /* Uploaded */ 2,
      "Dockerfile",
      path.name,
      path.content
    ];
  return {
    source: match[0],
    path: match[1],
    filename: match[2],
    content: match[3],
    context: config$1.context,
    target: Stdlib__Option.value(config$1.target, ""),
    arguments: JSON.stringify(Js__Js_dict.fromList(Stdlib__List.map((function (param) {
      return [
        param[0],
        Mapre_wire__Json.str(param[1])
      ];
    }), config$1.build_args)))
  };
}

function change(d, field, value) {
  switch (field) {
    case /* Path */ 0 :
      return {
        source: d.source,
        path: value,
        filename: d.filename,
        content: d.content,
        context: d.context,
        target: d.target,
        arguments: d.arguments
      };
    case /* Filename */ 1 :
      return {
        source: d.source,
        path: d.path,
        filename: value,
        content: d.content,
        context: d.context,
        target: d.target,
        arguments: d.arguments
      };
    case /* Content */ 2 :
      return {
        source: d.source,
        path: d.path,
        filename: d.filename,
        content: value,
        context: d.context,
        target: d.target,
        arguments: d.arguments
      };
    case /* Context */ 3 :
      return {
        source: d.source,
        path: d.path,
        filename: d.filename,
        content: d.content,
        context: value,
        target: d.target,
        arguments: d.arguments
      };
    case /* Target */ 4 :
      return {
        source: d.source,
        path: d.path,
        filename: d.filename,
        content: d.content,
        context: d.context,
        target: value,
        arguments: d.arguments
      };
    case /* Arguments */ 5 :
      return {
        source: d.source,
        path: d.path,
        filename: d.filename,
        content: d.content,
        context: d.context,
        target: d.target,
        arguments: value
      };
  }
}

function configuration(d) {
  try {
    const match = d.source;
    let exit = 0;
    switch (match) {
      case /* Native */ 0 :
        return /* Native */ 0;
      case /* Repository */ 1 :
      case /* Uploaded */ 2 :
        exit = 1;
        break;
    }
    if (exit === 1) {
      const match$1 = d.source;
      let dockerfile;
      let exit$1 = 0;
      switch (match$1) {
        case /* Native */ 0 :
        case /* Repository */ 1 :
          exit$1 = 2;
          break;
        case /* Uploaded */ 2 :
          dockerfile = Js__Js_dict.fromList({
            hd: [
              "kind",
              Mapre_wire__Json.str("uploaded")
            ],
            tl: {
              hd: [
                "name",
                Mapre_wire__Json.str(d.filename)
              ],
              tl: {
                hd: [
                  "content",
                  Mapre_wire__Json.str(d.content)
                ],
                tl: /* [] */ 0
              }
            }
          });
          break;
      }
      if (exit$1 === 2) {
        dockerfile = Js__Js_dict.fromList({
          hd: [
            "kind",
            Mapre_wire__Json.str("repository")
          ],
          tl: {
            hd: [
              "path",
              Mapre_wire__Json.str(d.path)
            ],
            tl: /* [] */ 0
          }
        });
      }
      const value = Js__Js_dict.fromList({
        hd: [
          "kind",
          Mapre_wire__Json.str("dockerfile")
        ],
        tl: {
          hd: [
            "dockerfile",
            dockerfile
          ],
          tl: {
            hd: [
              "context",
              Mapre_wire__Json.str(d.context)
            ],
            tl: {
              hd: [
                "target",
                d.target === "" ? null : Mapre_wire__Json.str(d.target)
              ],
              tl: {
                hd: [
                  "build_args",
                  JSON.parse(d.arguments)
                ],
                tl: /* [] */ 0
              }
            }
          }
        }
      });
      const value$1 = Mapre_wire__Environment_codec.decode(value);
      if (value$1.TAG === /* Ok */ 0) {
        return value$1._0;
      } else {
        return;
      }
    }
    
  }
  catch (raw_exn){
    const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.MEL_EXN_ID === Js__Js_exn.$$Error) {
      return;
    }
    throw exn;
  }
}

function loaded(t, receipt, request_id) {
  return {
    draft: draft(receipt.revision.configuration),
    version: receipt.revision.version,
    project_version: receipt.project_version,
    request_id,
    loading: false,
    pending: false,
    conflict: receipt.current_version !== receipt.revision.version,
    message: "",
    history: t.history,
    history_open: t.history_open,
    history_loading: t.history_loading,
    next_version: t.next_version
  };
}

function update(t, message) {
  if (/* tag */ typeof message !== "object" && typeof message !== "function") {
    switch (message) {
      case /* Reload */ 1 :
        return {
          draft: t.draft,
          version: t.version,
          project_version: t.project_version,
          request_id: t.request_id,
          loading: true,
          pending: t.pending,
          conflict: t.conflict,
          message: "",
          history: t.history,
          history_open: t.history_open,
          history_loading: t.history_loading,
          next_version: t.next_version
        };
      case /* Pending */ 3 :
        return {
          draft: t.draft,
          version: t.version,
          project_version: t.project_version,
          request_id: t.request_id,
          loading: t.loading,
          pending: true,
          conflict: t.conflict,
          message: "",
          history: t.history,
          history_open: t.history_open,
          history_loading: t.history_loading,
          next_version: t.next_version
        };
      case /* Conflict */ 4 :
        return {
          draft: t.draft,
          version: t.version,
          project_version: t.project_version,
          request_id: t.request_id,
          loading: t.loading,
          pending: false,
          conflict: true,
          message: "",
          history: t.history,
          history_open: t.history_open,
          history_loading: t.history_loading,
          next_version: t.next_version
        };
      case /* History_loading */ 7 :
        return {
          draft: t.draft,
          version: t.version,
          project_version: t.project_version,
          request_id: t.request_id,
          loading: t.loading,
          pending: t.pending,
          conflict: t.conflict,
          message: t.message,
          history: t.history,
          history_open: true,
          history_loading: true,
          next_version: t.next_version
        };
      default:
        return t;
    }
  } else {
    switch (message.TAG) {
      case /* Loaded */ 1 :
        return loaded(t, message._0, message._1);
      case /* Edited */ 4 :
        return {
          draft: message._0,
          version: t.version,
          project_version: t.project_version,
          request_id: message._1,
          loading: t.loading,
          pending: t.pending,
          conflict: t.conflict,
          message: "",
          history: t.history,
          history_open: t.history_open,
          history_loading: t.history_loading,
          next_version: t.next_version
        };
      case /* Saved */ 6 :
        const init = loaded(t, message._0, message._1);
        return {
          draft: init.draft,
          version: init.version,
          project_version: init.project_version,
          request_id: init.request_id,
          loading: init.loading,
          pending: init.pending,
          conflict: init.conflict,
          message: "Saved. Build and publish a template to use this environment in new sessions.",
          history: init.history,
          history_open: init.history_open,
          history_loading: init.history_loading,
          next_version: init.next_version
        };
      case /* Failed */ 7 :
        return {
          draft: t.draft,
          version: t.version,
          project_version: t.project_version,
          request_id: t.request_id,
          loading: false,
          pending: false,
          conflict: t.conflict,
          message: message._0,
          history: t.history,
          history_open: t.history_open,
          history_loading: false,
          next_version: t.next_version
        };
      case /* History_loaded */ 8 :
        const rows = message._0;
        return {
          draft: t.draft,
          version: t.version,
          project_version: t.project_version,
          request_id: t.request_id,
          loading: t.loading,
          pending: t.pending,
          conflict: t.conflict,
          message: t.message,
          history: message._2 ? Stdlib.$at(t.history, rows) : rows,
          history_open: t.history_open,
          history_loading: false,
          next_version: message._1
        };
      default:
        return t;
    }
  }
}

function can_save(t) {
  if (t.version !== undefined && !t.loading && !t.pending && !t.conflict) {
    return configuration(t.draft) !== undefined;
  } else {
    return false;
  }
}

export {
  empty,
  initial,
  draft,
  change,
  configuration,
  update,
  can_save,
}
/* Js__Js_exn Not a pure module */
